import styled from "styled-components";

const SelectBox = styled.div`
  background-color: ${({ selected, theme }) =>
    selected ? (theme.colors.primary || theme.colors.primaryLight) : "#ffffff"};
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 6px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  transition: background-color 0.15s ease, transform 0.1s ease;
  color: ${({ selected, theme }) => (selected ? "#ffffff" : theme.colors.textPrimary)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  user-select: none;
  border: ${({ selected, theme }) =>
    selected ? "none" : `1px solid ${theme.colors.borderLight}`};

  &:hover {
    background-color: ${({ selected, disabled, theme }) =>
      !selected && !disabled ? (theme.colors.primaryHover || "rgba(0,0,255,0.05)") : undefined};
  }

  &:active {
    transform: scale(0.98);
    pointer-events: auto;
  }
`;

export default SelectBox;